import React from "react";
import classes from "./AuthenticationPageLayout.module.scss";
import AccelerateLogo from "../../../assets/images/accelerate-logo-black.svg";

interface Props {
  children: React.ReactNode;
}

const AuthenticationPageLayout: React.FC<Props> = (props) => {
  return (
    <div className={classes.authLayoutContainer}>
      <div className={classes.contentWrapper}>
        <img
          src={AccelerateLogo}
          className={classes.logo}
          alt="Accelerate Logo"
        />
        {props.children}
      </div>
      <div className={classes.guide}>
        <iframe
          title="login-message"
          scrolling="no"
          src="https://info.ehs.com/login-message.html"
        />
      </div>
    </div>
  );
};

export default AuthenticationPageLayout;
